import { render, staticRenderFns } from "./ModifyRelatedProjectDialog.vue?vue&type=template&id=b2dad244&"
import script from "./ModifyRelatedProjectDialog.vue?vue&type=script&lang=js&"
export * from "./ModifyRelatedProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./ModifyRelatedProjectDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports